<template>
  <div>
    <div class="users-layout">
      <default-box
          :loader="loading">
        <router-view/>
        <div class="d-flex justify-content-between align-items-center mb-10">
          <div></div>
          <router-link-to
              default_button
              :route_name="route_names.benefit_cookie"
              :route_params="{id: 0}">
            {{ $t('committees.new') }}
          </router-link-to>
        </div>
        <tables-slot
            :empty_spacer="loading"
            @paginationFetch="fillData"
            @popstateEvent="fetchList"
            :pagination="pagination">
          <template v-slot:table_head>
            <td class="w-0 text-nowrap">#</td>
            <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
            <td class="w-0 text-nowrap" v-if="getUserRoleIsAdmin">{{ $t('tables.edit') }}</td>
          </template>
          <template v-slot:table_body>
            <tr v-for="cookie in cookies">
              <td class="w-0 text-nowrap">
                {{ cookie.id }}
              </td>
              <td class="w-0 text-nowrap">
                {{ cookie.title }}
              </td>
              <td class="w-0 text-nowrap">
                <router-link-to
                    class="d-inline-block px-10 py-10"
                    :route_params="{id: cookie.id}"
                    :route_name="route_names.benefit_cookie">
                  <edit-icon/>
                </router-link-to>
              </td>
            </tr>
          </template>
        </tables-slot>
      </default-box>

    </div>
    <notifier-block/>
  </div>
</template>

<script>

import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import EditIcon from "../../icons/EditIcon.vue";
import Switcher from "../../small_components/Switcher.vue";
import AsideDashboard from "../../small_components/AsideDashboard.vue";
import HeaderBlock from "../../parts/HeaderBlock.vue";
import NotifierBlock from "../../parts/NotifierBlock.vue";
import {
  axiosBelts,
  axiosBeltsCookie,
  axiosBenefits,
  axiosCommittees,
  axiosUsers
} from "../../../helpers/axios_requests";
import calendar_mixin from "../../../mixins/calendar_mixin";
import routes_mixin from "../../../mixins/routes_mixin";

export default {
  mixins: [calendar_mixin, routes_mixin],

  name: 'CookiesLayout',
  components: {
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,

  },

  computed: {
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      search: '',
      cookies: [],
      pagination: [],
    }
  },

  created() {
    this.loading = false;
    this.fetchList()
  },
  methods: {
    searchFetchList() {
      return true;
    },

    fillData({collection, pagination}) {
      this.cookies = collection || []
      this.pagination = pagination || []
    },

    fetchList() {
      this.loading = true
      axiosBeltsCookie.list()
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },
  }
}
</script>
